export enum ShippingType {
  DESPACHO = 'despacho',
  RETIRO = 'retiro',
  SUCURSAL = 'sucursal',
}
